<template>
  <div class="container_box">
    <!--头部筛选区域-->
    <div class="filter_box">
      <Form ref="pageParams" :model="pageParams" :label-width="labelWidth" @submit.native.prevent>
        <Row type="flex" :gutter="gutterItem">
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1002399')" prop="ymsWarehouseId">
              <Select v-model="pageParams.ymsWarehouseId" filterable @on-change="changeYmsWarehouseId">
                <Option v-for="item in ymsWarehouseList" :key="item.ymsWarehouseId" :value="item.ymsWarehouseId">{{ item.name }}</Option>
              </Select>
            </Form-item>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <FormItem :label="$t('key1002616')" prop="ymsWarehouseBlockId">
              <Select v-model="pageParams.ymsWarehouseBlockId" filterable :placeholder="pageParams.ymsWarehouseId !=='null' ? $t('key1000101') : $t('key1002615')">
                <Option v-for="item in reservoirAreaList" :key="item.ymsWarehouseBlockId" :value="item.ymsWarehouseBlockId">{{ item.name }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1002617')" prop="code">
              <Input v-model.trim="pageParams.code" clearable></Input>
            </Form-item>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <FormItem :label="$t('key1002618')">
              <local-tabButton :tabButtonList="reservoirStatusList" @selectStatus="reservoirStatusBtn"></local-tabButton>
            </FormItem>
          </Col>
          <Col style="min-width: 200px;" push="1">
            <Button @click="reset" icon="md-refresh" class="mr10">{{ $t('key1000109') }}</Button>
            <Button type="primary" @click="search" icon="md-search">{{ $t('key1000361') }}</Button>
          </Col>
        </Row>
      </Form>
    </div>
    <!--功能按钮操作区域-->
    <div class="operation_box">
      <!--新建库位-->
      <Button class="mr15" type="primary" @click="AddLocationBtn"
        v-if="getPermission('ymsWarehouseLocation_insert')">{{ $t('key1002612') }}</Button>
      <!--导入库位-->
      <Button class="mr15" type="primary" @click="$refs.commonImport.importModal = true">{{ $t('key1002621') }}</Button>
      <!--批量打印条码-->
      <Button class="mr15" type="primary" @click="batchPrintingBarcodeBtn">{{ $t('key1002330') }}</Button>
    </div>
    <!--列表区域-->
    <div class="table_box">
      <Table
        ref="selection"
        highlight-row
        :loading="tableLoading"
        border
        max-height="500"
        :columns="tableColumns"
        :data="tableData"
        @on-selection-change="tableChange"
        @on-sort-change="sortChange">
      </Table>
      <Page
        :transfer="true"
        v-if="!tableLoading"
        :total="total"
        @on-change="changePage"
        show-total
        :page-size="pageParams.pageSize"
        show-elevator
        :current="pageParams.pageNum"
        show-sizer
        @on-page-size-change="changePageSize"
        placement="top"
        :page-size-opts="pageArray">
      </Page>
    </div>
    <!--新建库位弹窗-->
    <Modal v-model="locationModal" :title="locationModalTitle" width="600"
      :transfer="false" :mask-closable="false" @on-visible-change="locationModalChange">
      <Form ref="locationForm" :model="locationForm" :rules="ruleValidate" :label-width="labelWidth"
        :disabled="locationTalg === 'look'" @submit.native.prevent>
        <Row>
          <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1002327')" prop="ymsWarehouseId">
              <Select v-model="locationForm.ymsWarehouseId" transfer filterable style="width: 80%;" @on-change="changeYmsWarehouse" :disabled="locationTalg !== 'add'">
                <Option v-for="item in ymsWarehouseData" :key="item.ymsWarehouseId" :value="item.ymsWarehouseId">{{ item.name }}</Option>
              </Select>
            </Form-item>
          </Col>
          <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1002324')" prop="ymsWarehouseBlockId">
              <Select v-model="locationForm.ymsWarehouseBlockId" transfer filterable style="width: 80%;" :disabled="locationTalg !== 'add'">
                <Option v-for="item in ymsWarehouseBlockList" :key="item.ymsWarehouseBlockId"
                  :value="item.ymsWarehouseBlockId">{{ item.name }}</Option>
              </Select>
            </Form-item>
          </Col>
          <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1002617')" prop="code">
              <Input clearable v-model.trim="locationForm.code" style="width: 80%;"></Input>
            </Form-item>
          </Col>
          <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1001522')" prop="status">
              <Select v-model="locationForm.status" transfer filterable style="width: 80%;">
                <Option v-for="(item, index) in statusLists" :value="item.value" :key="index">{{ item.name }}</Option>
              </Select>
            </Form-item>
          </Col>
        </Row>
      </Form>
      <template #footer>
        <div style="text-align: center;">
          <Button @click="locationModal = false">{{ $t('key1000112') }}</Button>
          <Button type="primary" @click="reservoirBtn" v-if="locationTalg !== 'look'">{{ $t('key1000111') }}</Button>
        </div>
      </template>
    </Modal>
    <!--打印条码弹窗-->
    <setPrintBarcodeModal
      ref="printBarcode"
      :printBarcodeTitle="$t('key1002619')"
      :labelTitle="$t('key1002610')"
      :tableTitle="$t('key1002620')"
      :printColumns="printColumns"
      :printData="printData"
      :printViewParams="['codeBarcode', 'code']"
      @changePrintNum="changePrintNum"
      @printBarcodeModalChange="printBarcodeModalChange"
    ></setPrintBarcodeModal>
    <!--导入的弹窗-->
    <commonImportModal
      ref="commonImport"
      :importTitle="$t('key1002621')"
      importType="Location"
      :uploadAction="uploadZoneExcel"
      @uploadSuccess="uploadSuccess"
      importTemplateKey="ymsWarehouseLocation">
      {{ $t('key1002622') }}<br/>
      {{ $t('key1002623') }} .xls .xlsx .csv;<br/>
      {{ $t('key1002624') }}<br/>
      {{ $t('key1002625') }}
    </commonImportModal>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from "@/components/mixin/common_mixin";
import api from '@/api/';
import setPrintBarcodeModal from "@/views/yms/components/basicSettings/components/setPrintBarcodeModal";
import commonImportModal from "@/components/common/commonImportModal";
import {getYmsWarehouseBlockList, getEnableWarehouseData, getWarehouseName, getWarehouseManageInfo} from "@/utils/common";

export default {
  name: "locationManage",
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      pageParams: {
        code: '',
        status: null,
        pageSize: 15,
        pageNum: 1,
        upDown: 'down',
        orderBy: 'createdTime',
        ymsWarehouseId: 'null',
        ymsWarehouseBlockId: null
      },
      total: 0,
      pageParamsStatus: false,
      ymsWarehouseLocationId: null,
      reservoirStatusList: [
        {
          selected: true,
          value: null,
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000110')
        },
        {
          selected: false,
          value: 0,
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000463')
        },
        {
          selected: false,
          value: 1,
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000419')
        }
      ],
      tableColumns: [
        {
          type: 'selection',
          width: 70,
          align: 'center'
        },
        {
          type: 'index',
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000343'),
          width: 75,
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002390'),
          key: 'warehouseName',
          align: 'center',
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002608'),
          key: 'warehouseBlockName',
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002609'),
          key: 'warehouseBlockCode',
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002610'),
          key: 'code',
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000461'),
          key: 'status',
          align: 'center',
          render(h, params) {
            let status = params.row.status;
            let text = '';
            v.statusLists.map((item) => {
              if (item.value === status) {
                text = item.name;
              }
            });
            return h('span', {
              class: status === 1 ? 'openStatus' : 'stopStatus'
            }, text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002159'),
          key: 'createdTime',
          align: 'center',
          sortable: 'custom',
          sortType: 'desc',
          render: (h, params) => {
            return h('span', v.$uDate.dealTime(params.row.createdTime, 'fulltime'));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
          key: 'action',
          align: 'center',
          width: 200,
          render: (h, params) => {
            return h('optsButtonList', {
              props: {
                operationList: [
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000401'),
                    show: v.getPermission('ymsWarehouseLocation_detail'),
                    clickFn: () => {
                      v.lookLocationBtn(params.row.ymsWarehouseLocationId);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000985'),
                    show: v.getPermission('ymsWarehouseLocation_update'),
                    clickFn: () => {
                      v.editLocationBtn(params.row.ymsWarehouseLocationId);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000462'),
                    show: params.row.status === 0 && v.getPermission('ymsWarehouseLocation_enable'),
                    clickFn: () => {
                      v.operationHandel('enable', params.row.ymsWarehouseLocationId);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000463'),
                    show: params.row.status === 1 && v.getPermission('ymsWarehouseLocation_disable'),
                    clickFn: () => {
                      v.operationHandel('disable', params.row.ymsWarehouseLocationId);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000594'),
                    show: true,
                    clickFn: () => {
                      v.printData = [params.row];
                      v.$refs['printBarcode'].setPrintBarcodeModal = true;
                    }
                  }
                ]
              },
              on: {
                setWidth(value) {
                  if (value) {
                    v.optionBtnWidth.push(value);
                    params.column.width = Math.max(...v.optionBtnWidth);
                    v.$forceUpdate();
                  }
                }
              }
            });
          }
        }
      ],
      tableData: [],
      statusLists: [
        {value: 0, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000463')},
        {value: 1, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000462')}
      ],
      ymsWarehouseList: [],
      reservoirAreaList: [],
      ymsWarehouseBlockList: [],
      ruleValidate: {
        ymsWarehouseId: [
          {
            required: true,
            message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002316'),
            trigger: 'change'
          }
        ],
        ymsWarehouseBlockId: [
          {
            required: true,
            message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002317'),
            trigger: 'blur'
          }
        ],
        code: [
          {
            required: true,
            message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002611'),
            trigger: 'blur'
          }
        ],
        status: [
          {
            type: 'number',
            required: true,
            message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002319'),
            trigger: 'change'
          }
        ]
      },
      locationModal: false,
      locationModalTitle: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002612'),
      locationTalg: 'add',
      locationForm: {
        ymsWarehouseId: null,
        ymsWarehouseBlockId: null,
        code: '',
        status: null
      },
      printColumns: [
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002610'),
          key: 'code',
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000328'),
          key: 'warehouseName',
          align: 'center',
          render(h, params) {
            return h('span', getWarehouseName(v.ymsWarehouseList, params.row.ymsWarehouseId));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000318'),
          key: 'printQuantity',
          align: 'center',
          width: 150,
          render: (h, params) => {
            return h('InputNumber', {
              props: {
                min: 1,
                max: 999999,
                value: this.printData[params.index].printQuantity,
                size: 'small'
              },
              on: {
                input: (val) => {
                  this.printData[params.index].printQuantity = val;
                }
              }
            });
          }
        }
      ],
      printData: [],
      uploadZoneExcel: api.post_ymsWarehouseLocation_excelImport,
    };
  },
  computed: {
    ymsWarehouseData() {
      return this.ymsWarehouseList.filter((item) => {
        return item.ymsWarehouseId !== 'null';
      });
    }
  },
  created() {
    this.ymsWarehouseList = [];
    getEnableWarehouseData(1).then((data) => {
      if (data && data.length > 0) {
        this.ymsWarehouseList = data;
        this.ymsWarehouseList.unshift({
          ymsWarehouseId: 'null',
          name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000110')
        });
      }
    });
    this.search();
  },
  methods: {
    // 查询按钮
    search() {
      this.pageParams.pageNum = 1;
      this.getList();
    },
    // 重置按钮
    reset() {
      let v = this;
      v.$refs['pageParams'].resetFields();
      v.reservoirStatusBtn(0, null);
      v.reservoirAreaList = [];
      v.getList();
    },
    // 参数处理
    handleParameter() {
      let v = this;
      let params = Object.assign({}, v.pageParams);
      let keyList = ['ymsWarehouseId'];
      for (let key of keyList) {
        params[key] = v.pageParams[key] === 'null' ? null : v.pageParams[key];
      }
      return params;
    },
    // 获取列表数据
    getList() {
      let v = this;
      v.tableData = [];
      v.total = 0;
      let ymsWarehouseLocationIds = [];
      if (v.getPermission('ymsWarehouseLocation_query')) {
        v.tableLoading = true;
        v.tableData = [];
        v.axios.post(api.post_ymsWarehouseLocation_query, v.handleParameter()).then(response => {
          if (response.data.code === 0) {
            let data = response.data.datas;
            let list = data.list || [];
            if (list.length > 0) {
              list.map((item) => {
                item['printQuantity'] = 1;
                ymsWarehouseLocationIds.push(item.ymsWarehouseLocationId);
              });
            }
            if (ymsWarehouseLocationIds.length > 0) {
              (async () => {
                v.tableData = await getWarehouseManageInfo(ymsWarehouseLocationIds, list);
                v.$nextTick(() => {
                  v.tableLoading = false;
                });
              })();
            } else {
              v.tableData = list;
              v.$nextTick(() => {
                v.tableLoading = false;
              });
            }
            v.total = data.total;
          } else {
            v.tableLoading = false;
          }
        });
      } else {
        v.gotoError();
      }
    },
    // 新建库位
    AddLocationBtn() {
      this.locationTalg = 'add';
      this.locationModal = true;
      this.locationModalTitle = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002612');
    },
    // 查看库位
    lookLocationBtn(ymsWarehouseLocationId) {
      this.locationTalg = 'look';
      this.locationModalTitle = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002613');
      this.getLocationDetails(ymsWarehouseLocationId);
    },
    // 编辑库位
    editLocationBtn(ymsWarehouseLocationId) {
      this.locationTalg = 'edit';
      this.locationModalTitle = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002614');
      this.getLocationDetails(ymsWarehouseLocationId);
    },
    // 获取库位详情数据
    getLocationDetails(ymsWarehouseLocationId) {
      this.ymsWarehouseLocationId = ymsWarehouseLocationId;
      this.axios.get(api.get_ymsWarehouseLocation + ymsWarehouseLocationId).then(response => {
        if (response.data.code === 0) {
          this.locationModal = true;
          let data = response.data.datas;
          if (data.ymsWarehouseId) {
            this.changeYmsWarehouse(data.ymsWarehouseId, data);
          }
        }
      });
    },
    // 选取库位状态
    reservoirStatusBtn(index, value) {
      let v = this;
      v.pageParams.status = value;
      v.reservoirStatusList.forEach((n, i) => {
        n.selected = i === index;
      });
    },
    // 新增、编辑库位弹窗的确定按钮
    reservoirBtn() {
      let v = this;
      let url = '';
      let method = 'post';
      let text = '';
      if (v.locationTalg === 'add') {
        url = api.post_ymsWarehouseLocation;
        method = 'post';
        text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001488');
      } else if (v.locationTalg === 'edit') {
        url = api.put_ymsWarehouseLocation;
        method = 'put';
        text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002279');
      }
      v.$refs['locationForm'].validate((valid) => {
        if (valid) {
          let query = {
            method: method,  // 请求的方法
            url: url,  // 接口
            data: Object.assign({}, v.locationForm),  // 参数
            config: {loading: true}
          };
          v.axios(query).then(response => {
            if (response.data.code === 0) {
              v.locationModal = false;
              v.$Message.success(text);
              v.pageParamsStatus = true;
            }
          });
        }
      });
    },
    // 选中仓库，获取对应的库区数据
    changeYmsWarehouse(value, dataObj) {
      if (value) {
        this.locationForm.ymsWarehouseBlockId = null;
        this.ymsWarehouseBlockList = [];
        getYmsWarehouseBlockList(value).then((newList) => {
          this.ymsWarehouseBlockList = newList;
          if (dataObj) {
            this.locationForm = dataObj;
          }
        });
      }
    },
    // 监听库位弹窗
    locationModalChange(value) {
      if (!value) {
        this.$refs['locationForm'].resetFields();
        this.locationTalg = 'add';
        this.locationModalTitle = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002612');
      }
    },
    // 启用、停用库位按钮
    operationHandel(type, ymsWarehouseLocationId) {
      let url = '';
      if (type === 'disable') {
        url = api.put_ymsWarehouseLocation_disable;
      } else {
        url = api.put_ymsWarehouseLocation_enable;
      }
      this.axios.put(url + ymsWarehouseLocationId).then(response => {
        if (response.data.code === 0) {
          this.pageParamsStatus = true;
          this.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000489'));
        }
      });
    },
    // 勾选列表数据
    tableChange(data) {
      if (data) {
        this.printData = data;
      }
    },
    // 批量打印条码
    batchPrintingBarcodeBtn() {
      if (this.printData.length > 0) {
        this.$refs.printBarcode.setPrintBarcodeModal = true;
      } else {
        this.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002323'));
        return false;
      }
    },
    // 统一设置打印数量
    changePrintNum(value) {
      let v = this;
      if (v.printData.length > 0) {
        v.printData.forEach((n, i) => {
          v.$set(v.printData[i], 'printQuantity', value);
        });
      }
    },
    // 关闭打印设置条码弹窗时，重置勾选数据
    printBarcodeModalChange() {
      let v = this;
      v.printData = [];
      v.$refs['selection'].selectAll(false);
    },
    // 导入成功的回调
    uploadSuccess() {
      this.pageParamsStatus = true;
    },
    // 选择所属仓库
    changeYmsWarehouseId(value) {
      if (value) {
        this.reservoirAreaList = [];
        getYmsWarehouseBlockList(value).then((newList) => {
          this.reservoirAreaList = newList;
        });
      }
    },
    // 时间排序
    sortChange(data) {
      let obj = {
        desc: 'down',
        asc: 'up'
      };
      this.pageParams.upDown = obj[data.order];
      this.pageParams.orderBy = data.key;
      this.pageParamsStatus = true;
    }
  },
  watch: {
    pageParamsStatus(value) {
      let v = this;
      if (value) {
        v.getList();
        v.pageParamsStatus = false;
      }
    }
  },
  components: {
    setPrintBarcodeModal,
    commonImportModal
  }
};
</script>

<style scoped>

</style>
